export default function takeOverConsole() {
  if (process.env.REACT_APP_LOGER === "disabled") {
    window.console.log = () => {};
    window.console.debug = () => {};
    window.console.error = () => {};
    window.console.warn = () => {};
    //window.console.info = () => {};
  }
}
